import { getItemFromCloudStorage } from "@gameApp/helpers/getItemFromCloudStorage";

export async function webAppAuthTokensGet(): Promise<
  [string | null, string | null]
> {
  const [tokenAccess, tokenRefresh] = await Promise.all([
    getItemFromCloudStorage("accessToken"),
    getItemFromCloudStorage("refreshToken"),
  ]);

  return [tokenAccess || null, tokenRefresh || null];
}
